module.exports = "/_next/static/images/rhode-island-b3e4ce50470199bb7d812adac006015e.svg";